<template>
    <Teleport to=".frame-common">
        <div class="modal" :class="class" :id="id" @click="clickedOnBackgroundEvent" ref="background">
            <div class="modal__content">
                <div class="modal__content__header">
                    <slot name="header">
                        <div class="modal__content__header__title">
                            <slot name="header-title"></slot>
                        </div>
                        <div class="modal__content__header__cancel">
                            <slot name="header-cancel">
                                <div @click="cancelModalEvent">×</div>
                            </slot>
                        </div>
                    </slot>
                </div>
                <div class="modal__content__body">
                    <slot name="body"></slot>
                </div>
                <div class="modal__content__footer">
                    <slot name="footer">
                        <div v-if="displayDefaultCancelButton" class="modal__content__footer__cancel">
                            <slot name="footer-cancel">
                                <Button @click="cancelModalEvent">{{ $t('labels.cancel') }}</Button>
                            </slot>
                        </div>
                        <div class="modal__content__footer__other">
                            <slot name="footer-other"></slot>
                        </div>
                    </slot>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import Button from "./buttons/Button.vue";

export default {
    components: {Button},

    props: {
        backgroundClickEvent: {
            required: false,
            type: [Function, Boolean],
            default: true
        },

        displayDefaultCancelButton: {
            required: false,
            type: Boolean,
            default: true
        },

        class: {
            required: false,
            default: null
        },

        id: {
            required: false,
            default: null
        }
    },

    emits: ['modal:cancel'],

    methods: {
        cancelModalEvent() {
            this.$emit('modal:cancel');
        },

        clickedOnBackgroundEvent($event) {
            if($event.target !== this.$refs.background) {
                return;
            }

            switch(typeof this.backgroundClickEvent) {
                case 'boolean':
                    if(this.backgroundClickEvent) {
                        this.cancelModalEvent();
                    }
                    break;
                case 'function':
                    this.backgroundClickEvent($event, this);
                    break;
            }
        }
    }
}
</script>

<style lang="scss">
@use "../../scss/mixins";

.modal {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: var(--modal-background-color);
    color: var(--modal-font-color);
    display: grid;
    align-items: center;
    justify-items: center;

    overflow: hidden;

    &__content {
        position: absolute;
        background-color: var(--modal-body-background-color);
        color: var(--modal-body-color);
        min-width: 40%;
        max-width: 90%;
        max-height: 95dvh;
        @include mixins.box-shadow($top: 5px, $left: 5px, $blur: 5px);

        overflow: hidden;

        &__header {
            display: grid;
            grid-template-columns: 1fr auto;
            gap: var(--gap);
            background-color: var(--modal-header-background-color);
            color: var(--modal-header-font-color);
            padding: var(--padding-thin) var(--padding);

            &__cancel {
                cursor: pointer;
                width: 1em;
                text-align: center;
            }
        }

        &__body {
            padding: var(--padding-thin);

            overflow-y: auto;
            max-height: 80dvh;
        }

        &__footer {
            margin-top: var(--margin-thin);
            display: flex;
            gap: var(--gap-thin);
            flex-direction: row-reverse;
            padding: var(--padding-thin);
            padding-top: 0;
        }
    }

    //--modal-background-color: #{$modal-background-color};
    //--modal-body-background-color: #{$modal-body-background-color};
    //--modal-header-background-color: #{$modal-header-background-color};
    //--modal-body-color: #{$modal-body-color};
    //--modal-font-color: #{$modal-font-color};
    //--modal-header-font-color: #{$modal-header-font-color};
}
</style>
